import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Phone, Calendar } from 'lucide-react';

const CallToAction = () => {
  return (
    <section className="bg-gradient-to-r from-ventura-blue to-ventura-darkBlue text-white py-16">
      <div className="container mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Ready to Transform Your Property?
        </h2>
        
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto opacity-90">
          Book our <Link to="/services" className="text-yellow-300 hover:text-yellow-200 underline font-semibold">professional cleaning services</Link> today and enjoy a pristine, refreshed space!
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8">
          <Button 
            className="bg-white text-ventura-blue hover:bg-gray-100 text-lg px-8 py-6 rounded-full"
            onClick={() => window.location.href = "tel:+18054647166"}
          >
            <Phone className="mr-2" size={20} />
            Call Us Now
          </Button>
          
          <Button 
            className="bg-ventura-green text-white hover:bg-green-600 text-lg px-8 py-6 rounded-full"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
          >
            <Calendar className="mr-2" size={20} />
            Book Now
          </Button>
        </div>
        
        <div className="flex flex-wrap justify-center gap-3 text-sm opacity-90">
          <Link to="/services/pressure-washing" className="hover:text-yellow-300 underline">Ventura Pressure Washing</Link>
          <span className="text-white/50">•</span>
          <Link to="/services/window-washing" className="hover:text-yellow-300 underline">Window Cleaning Services</Link>
          <span className="text-white/50">•</span>
          <Link to="/services/carpet-cleaning" className="hover:text-yellow-300 underline">Carpet Care Ventura County</Link>
          <span className="text-white/50">•</span>
          <Link to="/services/gutter-cleaning" className="hover:text-yellow-300 underline">Gutter Cleaning Experts</Link>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
